import React, { ChangeEvent, useEffect, useState } from "react";

import { SelectProps } from "./Select.types";
import SelectIcon from './assets/selecticon.svg';
import "./Select.scss";

export const Select: React.FC<SelectProps> = ({ label, placeholder, children, required, error = false, errorMessage, customClass = '', disabled, name, onSelect, tabIndex }) => {

  const [selectedOption, setSelectedOption] = useState<null | string>(null);
  const [className, setClassName] = useState<string>('');

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(e.target.value);
    if (onSelect) {
      onSelect(e);
    }
  }

  useEffect(() => {
    if (!selectedOption) {
      setClassName(`${customClass} select-placeholder`);
    } else {
      setClassName(`${customClass}`);
    }
  }, [selectedOption]);

  return (
    <div className={"select-wrapper"}>
      {label && <label htmlFor={"select-general"}>{required && '*'} {label}</label>}
      <div className={"select-content"}>
        <img src={SelectIcon} className={"icon"} />
        <select name={name} onChange={handleChange} className={error ? `select-error ${className}` : `${className}`} disabled={disabled} tabIndex={tabIndex}>
          {placeholder && <option value="" disabled selected>{placeholder}</option>}
          {!placeholder && <option value="" disabled selected />}
          {children}
        </select>
      </div>
      {error &&
        <p className={"error-message"}>{errorMessage}</p>
      }
    </div>
  )
};

